import { useTheme } from 'foundations-theming/utils';
import { useCallback, useEffect, useRef, useState } from 'react';
import DocumentPreviewPopover from './DocumentPreviewPopover';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import contentOutputs from '../../editorCapabilities/ContentOutputTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DocumentPreviewTable = ({
  documentId,
  previewImage,
  previewTitle,
  setPreviewTitle,
  description,
  setDescription,
  documentName,
  showEditPreview,
  setShowEditPreview,
  editable,
  outputType,
  tokenTag,
  updatePreview
}) => {
  const trellisTheme = useTheme();
  const ref = useRef(null);
  const previewRef = useRef(null);
  const [imageFailed, setImageFailed] = useState(false);
  const handleOutsideClick = useCallback(event => {
    var _ref$current, _previewRef$current;
    if (!((_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.contains(event.target)) && !((_previewRef$current = previewRef.current) !== null && _previewRef$current !== void 0 && _previewRef$current.contains(event.target))) {
      setShowEditPreview(false);
    }
  }, [setShowEditPreview]);
  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [handleOutsideClick]);
  const documentLink = outputType !== contentOutputs.EDITABLE ? /*#__PURE__*/_jsx("span", {
    className: "ProseMirror__documents",
    children: /*#__PURE__*/_jsx("a", {
      href: tokenTag,
      target: "_blank",
      rel: "noreferrer",
      children: tokenTag
    })
  }) : /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "draftPlugins.documents.mergeTag.tooltip"
    }),
    placement: "top",
    children: /*#__PURE__*/_jsx("span", {
      style: {
        height: '20px',
        width: 'auto',
        padding: '4px 8px',
        backgroundColor: trellisTheme.color['do-not-use-oz-light'],
        borderRadius: '2px',
        color: trellisTheme.color['do-not-use-oz'],
        border: 'solid 1px transparent'
      },
      children: documentName
    })
  });
  return /*#__PURE__*/_jsxs("figure", {
    className: "m-top-6",
    style: {
      position: 'relative',
      display: 'inline-block',
      width: '400px'
    },
    ref: ref,
    children: [/*#__PURE__*/_jsx("table", {
      className: showEditPreview ? 'document-link-preview-selected-table' : '',
      style: {
        cursor: 'pointer',
        width: '100%',
        border: 'solid 1px #00a4bd',
        padding: '8px',
        borderRadius: '2px',
        marginBottom: '0'
      },
      "data-hs-document-link-preview-id": documentId,
      onClick: () => {
        if (!editable || outputType !== contentOutputs.EDITABLE) return;
        setShowEditPreview(true);
      },
      children: /*#__PURE__*/_jsx("tbody", {
        children: /*#__PURE__*/_jsxs("tr", {
          children: [/*#__PURE__*/_jsx("td", {
            style: {
              textAlign: 'center'
            },
            children: /*#__PURE__*/_jsx("img", {
              src: previewImage,
              alt: previewTitle,
              className: "document-link-preview-image",
              onError: () => {
                setImageFailed(true);
              },
              style: Object.assign({
                display: 'block',
                margin: '0 auto',
                maxWidth: '150px',
                maxHeight: '150px'
              }, imageFailed ? {
                width: 0,
                height: 0
              } : {})
            })
          }), /*#__PURE__*/_jsxs("td", {
            style: {
              paddingLeft: '8px',
              textAlign: 'left'
            },
            children: [/*#__PURE__*/_jsx("h2", {
              className: "document-link-preview-name",
              style: {
                color: '#33475b',
                marginTop: '0',
                marginBottom: '8px'
              },
              children: previewTitle
            }), /*#__PURE__*/_jsx("p", {
              className: "document-link-preview-description",
              style: {
                color: '#33475b',
                marginBottom: '8px'
              },
              children: description
            }), documentLink]
          })]
        })
      })
    }), showEditPreview && /*#__PURE__*/_jsx(DocumentPreviewPopover, {
      previewTitle: previewTitle,
      description: description,
      setPreviewTitle: setPreviewTitle,
      setDescription: setDescription,
      ref: previewRef,
      updatePreview: updatePreview
    })]
  });
};
export default DocumentPreviewTable;